import { render } from "./PartVehicleItem.vue?vue&type=template&id=6dfc58d7&scoped=true&bindings={}"
import script from "./PartVehicleItem.vue?vue&type=script&lang=ts"
export * from "./PartVehicleItem.vue?vue&type=script&lang=ts"

import "./PartVehicleItem.vue?vue&type=style&index=0&id=6dfc58d7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6dfc58d7"

export default script